import React from 'react';
import {
	Box,
	Container,
	Typography,
	makeStyles,
	Button
} from '@material-ui/core';
import Page from 'src/components/Page';
import { keycloak } from '../../config/keycloak';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		height: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	},
	image: {
		marginTop: 50,
		display: 'inline-block',
		maxWidth: '100%',
		width: 560
	}
}));

const NotFoundView = ({ error }) => {
	const classes = useStyles();

	return (
		<Page
			className={classes.root}
			title="404"
		>
			<Box
				display="flex"
				flexDirection="column"
				height="100%"
				justifyContent="center"
			>
				<Container maxWidth="md" >
					<Typography
						align="center"
						color="textPrimary"
						variant="h1"
					>
						Error occurred
					</Typography>
					<Typography
						align="center"
						color="textPrimary"
						variant="subtitle2"
					>
						{error}
					</Typography>
					<Box textAlign="center" >
						<Button style={{ top: '20px' }} variant='contained' color='primary' onClick={() => keycloak.logout()}>Logout</Button>
					</Box>
					<Box textAlign="center" >
						<img
							alt="Unauthorised"
							className={classes.image}
							src="/static/images/undraw_resume_folder_2_arse.svg"
						/>
					</Box>
				</Container>
			</Box>
		</Page>
	);
};

export default NotFoundView;
